import { render, staticRenderFns } from "./AppCadastro.vue?vue&type=template&id=728665f5&"
import script from "./AppCadastro.vue?vue&type=script&lang=js&"
export * from "./AppCadastro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports